import Trash from '@uhg-uicl/ui-core/dist/Trash';
import { Download, GridCell } from '@uhg-uicl/ui-core/dist';
import {
  RuleSpecLookupsData,
  RulesHeaderData,
  RulesInitialStateType,
  UserColumnConfigType,
} from './types';
import { ENV_CONSTANT } from 'constants/enums';

export const RULES_EMPTY_GRID_RECORD_MESSAGE = 'No records to display at this time.';

export enum ActionTypesRules {
  SET_RULE_SPECS_GRID_DATA = 'SET_RULE_SPECS_GRID_DATA',
  SET_RULE_SPEC_CATEGORIES = 'SET_RULE_SPEC_CATEGORIES',
  TOGGLE_RULES_LOADING = 'TOGGLE_RULES_LOADING',
  TOGGLE_SHOW_RULES_GRID = 'TOGGLE_SHOW_RULES_GRID',
  TOGGLE_RULES_ADVANCED_SEARCH_GRID = 'TOGGLE_RULES_ADVANCED_SEARCH_GRID',
  TOGGLE_DETAIL_PANE_LOADING = 'TOGGLE_DETAIL_PANE_LOADING',
  SET_RULES_HEADER_DATA = 'SET_RULES_HEADER_DATA',
  CLEAR_RULES_DETAIL_PANE_REDUX_DATA = 'CLEAR_RULES_DETAIL_PANE_REDUX_DATA',
  TOGGLE_RULES_HEADER_LOADING = 'TOGGLE_RULES_HEADER_LOADING',
  TOGGLE_RULES_CATEGORIES_LOADING = 'TOGGLE_RULES_CATEGORIES_LOADING',
  TOGGLE_RULE_SPEC_LOOKUPS_LOADING = 'TOGGLE_RULE_SPEC_LOOKUPS_LOADING',
  SET_RULE_SPEC_LOOKUPS_DATA = 'SET_RULE_SPEC_LOOKUPS_DATA',
  SET_RULE_SPEC_ADV_SEARCH_DATA = 'SET_RULE_SPEC_ADV_SEARCH_DATA',
  TOGGLE_RULE_ATTACHMENTS_LOADING = 'TOGGLE_RULE_ATTACHMENTS_LOADING',
  SET_RULE_ATTACHMENT_INFO_DATA = 'SET_RULE_ATTACHMENT_INFO_DATA',
  SET_USER_CONFIG_REDUX = 'SET_USER_CONFIG_REDUX',
  TOGGLE_RESET_RULE_GRID = 'TOGGLE_RESET_RULE_GRID',
  TOGGLE_IS_RULE_HISTORY_DATA_LOADING = 'TOGGLE_IS_RULE_HISTORY_DATA_LOADING',
  SET_RULE_HISTORY_DATA = 'SET_RULE_HISTORY_DATA',
  SET_RULE_SPECS_ADV_SEARCH_GRID_DATA = 'SET_RULE_SPECS_ADV_SEARCH_GRID_DATA',
  SET_RULE_DETAIL_PANE_BREADCRUMB_ITEMS = 'SET_RULE_DETAIL_PANE_BREADCRUMB_ITEMS',
  TOGGLE_RULE_BREADCRUMB = 'TOGGLE_RULE_BREADCRUMB',
  TOGGLE_IS_RULES_HEADER_LOADING = 'TOGGLE_IS_RULES_HEADER_LOADING',
  SET_DISABLED_COLUMNS = 'SET_DISABLED_COLUMNS',
}
export const RULE_SEARCH_PLACEHOLDER = 'Search by Rule Number or Rule Name';
export const rulesDetailPaneInitialState: any = {
  isDetailPaneLoading: false,
  rulesHeaderData: {} as RulesHeaderData,
  isRulesHeaderLoading: false,
  ruleHistoryData: [],
  isRuleHistoryDataLoading: false,
  breadCrumbItemsDetailPane: [],
  ruleAttachmentInfoData: [],
  isRuleAttachmentInfoLoading: false,
};
export const duplicateRuleErrorMsg = 'This is a duplicate.';
export const ruleTypeOptions = [
  {
    id: 1,
    value: 'crossClaim',
    label: 'Cross Claim',
  },
  {
    id: 2,
    value: 'reducingEdit',
    label: 'Reducing Edit',
  },
  {
    id: 3,
    value: 'partialDenial',
    label: 'Partial Denial',
  },
];
export const attachDocMessages = {
  attachDocument: 'Attach a Document',
  fileTypeError: 'Uploading of this file type is not allowed.',
  fileSizeError: 'File cannot exceed 100MB in size.',
  exceededMaxError: 'You may only upload 5 files at a time.',
  fileError: 'Please select a file.',
  enterANote: 'Enter a Note.',
  save: 'Save',
  cancel: 'Cancel',
  note: 'Note',
};
export const RULE_ACTIONS_DROPDOWN_MENUS_DEFAULT = [
  {
    id: 1,
    label: 'Attach a Document',
  },
];
export const claimTypeOptions = [
  {
    value: 'CMS1500',
    label: 'CMS-1500',
  },
  {
    value: 'UB04',
    label: 'UB04',
  },
  {
    value: 'Both',
    label: 'Both',
  },
];

export const RULE_ATTACHMENTS_GRID_COLUMNS = new Set([
  {
    dataName: 'fileName',
    text: 'File Name',
    cellType: 'custom',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'download',
    text: <GridCell cellType="icon" data={{ icon: Download }} />,
    cellType: 'custom',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'modifiedDate',
    text: 'Date/Time',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'trashIcon',
    text: <GridCell cellType="icon" data={{ icon: Trash }} />,
    sortable: true,
    isSorted: 0,
    cellType: 'custom',
    isHeaderTruncated: true,
    headerWidth: 50,
  },
]);

export const autoAdjudicationOptions = [
  {
    value: 'Standard',
    label: 'Standard',
  },
  {
    value: 'Client Dependent',
    label: 'Client Dependent',
  },
  {
    value: 'None',
    label: 'None',
  },
];
export const partnerServiceIdOptions = [
  { label: '38 - CE', value: '38' },
  { label: '40 - ECE', value: '40' },
  { label: '42 - IRR', value: '42' },
];

export const RULE_HISTORY_GRID_COLUMNS = new Set([
  {
    dataName: 'ruleSpecKeyLink',
    text: 'Rule Spec Key',
    sortable: true,
    isSorted: 0,
    cellType: 'custom',
  },
  {
    dataName: 'revisedDate',
    text: 'Last Modified',
    sortable: true,
    isSorted: 0,
  },
  {
    dataName: 'revisedBy',
    text: 'Modified By',
    sortable: true,
    isSorted: 0,
  },
]);

export const RULES_GRID_COLUMNS = new Set([
  {
    dataName: 'ruleId',
    text: 'Rule Number',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 180,
  },
  {
    dataName: 'ruleName',
    text: 'Rule Name',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 430,
  },
  {
    dataName: 'ruleCategory',
    text: 'Rule Category',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 150,
  },
  {
    dataName: 'ruleSubCategory',
    text: 'Rule Sub Category',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 350,
  },
  {
    dataName: 'reasonCode',
    text: 'Reason Code',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 75,
  },
  {
    dataName: 'serviceID',
    text: 'Service ID',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 85,
  },
  {
    dataName: 'statusChip',
    text: 'Status',
    sortable: true,
    isSorted: 0,
    cellType: 'chip',
    isHeaderTruncated: true,
    headerWidth: 80,
  },
  {
    dataName: 'revisedBy',
    text: 'Modified By',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 100,
  },
  {
    dataName: 'revisedDate',
    text: 'Last Modified',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 85,
  },
  {
    dataName: 'crossClaimCheck',
    text: 'Cross Claim',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 70,
    cellType: 'custom',
  },
  {
    dataName: 'reducingEditCheck',
    text: 'Reducing Edit',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 80,
    cellType: 'custom',
  },
  {
    dataName: 'partialDenialCheck',
    text: 'Partial Denial',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 75,
    cellType: 'custom',
  },
  {
    dataName: 'autoAdjudicate',
    text: 'Auto-Adjudication',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 105,
  },
  {
    dataName: 'claimType',
    text: 'Claim Type',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 80,
  },
  {
    dataName: 'productionDate',
    text: 'Production Date',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 95,
  },
  {
    dataName: 'modifier',
    text: 'Modifier',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 450,
  },
  {
    dataName: 'sourceRationale',
    text: 'Source Rationale',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 650,
  },
  {
    dataName: 'ruleVersionKey',
    text: 'Rule Version Key',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 75,
  },
  // {
  //   dataName: 'checkHistoryString',
  //   text: 'Check History',
  //   sortable: true,
  //   isSorted: 0,
  //   isHeaderTruncated: true,
  //   headerWidth: 75,
  // },
  {
    dataName: 'codeRange',
    text: 'Code Range',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 400,
  },
  {
    dataName: 'createdBy',
    text: 'Created By',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 100,
  },
  {
    dataName: 'description',
    text: 'Description',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 800,
  },
  {
    dataName: 'documentReferenceKey',
    text: 'Document Ref Key',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 110,
  },
  {
    dataName: 'documentReference',
    text: 'Document Reference',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 400,
  },
  {
    dataName: 'endDate',
    text: 'End Date',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 95,
  },
  {
    dataName: 'effectiveDate',
    text: 'Effective Date',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 95,
  },
  {
    dataName: 'eorSubtaskLanguage',
    text: 'EOR Subtask Language',
    sortable: true,
    isSorted: 0,
    isHeaderTruncated: true,
    headerWidth: 400,
  },
]);

export const defaultDisabledColumns = [
  'sourceRationale',
  'ruleVersionKey',
  // 'checkHistoryString',
  'codeRange',
  'createdBy',
  'description',
  'documentReferenceKey',
  'documentReference',
  'effectiveDate',
  'endDate',
  'eorSubtaskLanguage',
];

export const getFolderPathByEnv = () => {
  switch (window._env_.REACT_APP_ENV) {
    case ENV_CONSTANT.LOCAL:
      return `DEV_portal-rulespec-attachments/`;
    case ENV_CONSTANT.DEVELOP:
      return `DEV_portal-rulespec-attachments/`;
    case ENV_CONSTANT.UAT:
      return `CERT_portal-rulespec-attachments/`;
    case ENV_CONSTANT.PRODUCTION:
      return `PROD_portal-rulespec-attachments/`;
    default:
      return `DEV_portal-rulespec-attachments/`;
  }
};
